webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGE_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAGE_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MEDIA_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IMAGE_URLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOCATIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_earth4_jpg__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_earth4_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_earth4_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_earth_bump_jpg__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_earth_bump_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_earth_bump_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_earth_spec_jpg__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_earth_spec_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_earth_spec_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_earth_cloud_png__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_earth_cloud_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_earth_cloud_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_i_namibia_png__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_i_namibia_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_i_namibia_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_i_mariana_png__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_i_mariana_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_i_mariana_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_i_greenland_png__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_i_greenland_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_i_greenland_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_i_galapagos_png__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_i_galapagos_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_i_galapagos_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_i_antarctica_png__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_i_antarctica_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_i_antarctica_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_kf_cloud_00000_jpg__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_kf_cloud_00000_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_kf_cloud_00000_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_kf_cloud_00001_jpg__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_kf_cloud_00001_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_kf_cloud_00001_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_kf_cloud_00002_jpg__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_kf_cloud_00002_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_kf_cloud_00002_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_kf_cloud_00003_jpg__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_kf_cloud_00003_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_kf_cloud_00003_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_kf_cloud_00004_jpg__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_kf_cloud_00004_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_kf_cloud_00004_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_kf_cloud_00005_jpg__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_kf_cloud_00005_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_kf_cloud_00005_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_kf_cloud_00006_jpg__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_kf_cloud_00006_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_kf_cloud_00006_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_kf_cloud_00007_jpg__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_kf_cloud_00007_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_kf_cloud_00007_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_kf_cloud_00008_jpg__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_kf_cloud_00008_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_kf_cloud_00008_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_kf_cloud_00009_jpg__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_kf_cloud_00009_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_kf_cloud_00009_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_kf_cloud_00010_jpg__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_images_kf_cloud_00010_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_images_kf_cloud_00010_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_kf_cloud_00011_jpg__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_images_kf_cloud_00011_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_images_kf_cloud_00011_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_kf_cloud_00012_jpg__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_images_kf_cloud_00012_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_images_kf_cloud_00012_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_bg_meteor_png__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_images_bg_meteor_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_images_bg_meteor_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_wx_share_img_png__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_images_wx_share_img_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_images_wx_share_img_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_videos_video_sprite_mp4__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_videos_video_sprite_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_videos_video_sprite_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_sounds_music_sprite_mp3__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_sounds_music_sprite_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_sounds_music_sprite_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_sounds_music_bg_mp3__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_sounds_music_bg_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_sounds_music_bg_mp3__);




























var PAGE_WIDTH = 375;
var PAGE_HEIGHT = 600;

var MEDIA_URLS = {
  videoSprite: __WEBPACK_IMPORTED_MODULE_24__assets_videos_video_sprite_mp4___default.a,
  audioSprite: __WEBPACK_IMPORTED_MODULE_25__assets_sounds_music_sprite_mp3___default.a,
  backgroundAudio: __WEBPACK_IMPORTED_MODULE_26__assets_sounds_music_bg_mp3___default.a
};

var IMAGE_URLS = {
  earth: __WEBPACK_IMPORTED_MODULE_0__assets_images_earth4_jpg___default.a,
  earthBump: __WEBPACK_IMPORTED_MODULE_1__assets_images_earth_bump_jpg___default.a,
  earthSpec: __WEBPACK_IMPORTED_MODULE_2__assets_images_earth_spec_jpg___default.a,
  earthCloud: __WEBPACK_IMPORTED_MODULE_3__assets_images_earth_cloud_png___default.a,
  iNambia: __WEBPACK_IMPORTED_MODULE_4__assets_images_i_namibia_png___default.a,
  iMariana: __WEBPACK_IMPORTED_MODULE_5__assets_images_i_mariana_png___default.a,
  iGreenland: __WEBPACK_IMPORTED_MODULE_6__assets_images_i_greenland_png___default.a,
  iGalapagos: __WEBPACK_IMPORTED_MODULE_7__assets_images_i_galapagos_png___default.a,
  iAntarcica: __WEBPACK_IMPORTED_MODULE_8__assets_images_i_antarctica_png___default.a,
  cloud0: __WEBPACK_IMPORTED_MODULE_9__assets_images_kf_cloud_00000_jpg___default.a,
  cloud1: __WEBPACK_IMPORTED_MODULE_10__assets_images_kf_cloud_00001_jpg___default.a,
  cloud2: __WEBPACK_IMPORTED_MODULE_11__assets_images_kf_cloud_00002_jpg___default.a,
  cloud3: __WEBPACK_IMPORTED_MODULE_12__assets_images_kf_cloud_00003_jpg___default.a,
  cloud4: __WEBPACK_IMPORTED_MODULE_13__assets_images_kf_cloud_00004_jpg___default.a,
  cloud5: __WEBPACK_IMPORTED_MODULE_14__assets_images_kf_cloud_00005_jpg___default.a,
  cloud6: __WEBPACK_IMPORTED_MODULE_15__assets_images_kf_cloud_00006_jpg___default.a,
  cloud7: __WEBPACK_IMPORTED_MODULE_16__assets_images_kf_cloud_00007_jpg___default.a,
  cloud8: __WEBPACK_IMPORTED_MODULE_17__assets_images_kf_cloud_00008_jpg___default.a,
  cloud9: __WEBPACK_IMPORTED_MODULE_18__assets_images_kf_cloud_00009_jpg___default.a,
  cloud10: __WEBPACK_IMPORTED_MODULE_19__assets_images_kf_cloud_00010_jpg___default.a,
  cloud11: __WEBPACK_IMPORTED_MODULE_20__assets_images_kf_cloud_00011_jpg___default.a,
  cloud12: __WEBPACK_IMPORTED_MODULE_21__assets_images_kf_cloud_00012_jpg___default.a,
  meteor: __WEBPACK_IMPORTED_MODULE_22__assets_images_bg_meteor_png___default.a,
  wxShareImg: __WEBPACK_IMPORTED_MODULE_23__assets_images_wx_share_img_png___default.a
};

var LOCATIONS = [{
  name: 'namibia',
  coord: [-19.2, 14.11666667],
  position: [4.6, -1.29, -2.42],
  cameraFarPosition: [-20.03, 13.47, -14.61],
  cameraNearPosition: [-3.54, 2.38, -2.58],
  imageName: 'iNambia',
  coordSpriteIndex: 4,
  videoSprite: [10.80, 19.10],
  soundSprite: [0, 10.057142857142857]
}, {
  name: 'mariana',
  coord: [18.25, 142.81666667],
  position: [-4.390, 2.660, -2.410],
  cameraFarPosition: [26.46, -6.94, -9.96],
  cameraNearPosition: [4.52, -1.30, -1.63],
  imageName: 'iMariana',
  coordSpriteIndex: 3,
  videoSprite: [2.80, 8.40],
  soundSprite: [24, 34.10938775510204]
}, {
  name: 'greenland',
  coord: [72.16666667, -43],
  position: [1.880, 5.09, 0.89],
  cameraFarPosition: [7.24, 26.52, 7.06],
  cameraNearPosition: [1.30, 4.66, 1.24],
  imageName: 'iGreenland',
  coordSpriteIndex: 2,
  videoSprite: [40.20, 47.80],
  soundSprite: [48, 58.10938775510204]
}, {
  name: 'galapagos',
  coord: [1.33333333, -91.15],
  position: [0.550, 0.024, 5.39],
  cameraFarPosition: [-0.60, 0.14, 28.21],
  cameraNearPosition: [-0.10, 0.024, 4.99],
  imageName: 'iGalapagos',
  coordSpriteIndex: 1,
  videoSprite: [22.00, 37.43],
  soundSprite: [12, 22.057142857142857]
}, {
  name: 'antarctica',
  coord: [-77.96666667, -155.63333333],
  position: [-1.32, -5.05, 0.98],
  cameraFarPosition: [-7.88, -27.00, 1.87],
  cameraNearPosition: [-1.39, -4.75, 0.33],
  imageName: 'iAntarcica',
  coordSpriteIndex: 0,
  videoSprite: [50.90, 69.00],
  soundSprite: [36, 46.05714285714286]
}];

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCanvasImage */
/* harmony export (immutable) */ __webpack_exports__["a"] = getTexture;
/* unused harmony export isSamePosition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__ = __webpack_require__(1);



var loader = new __WEBPACK_IMPORTED_MODULE_0_three__["TextureLoader"]();
loader.crossOrigin = '';

function getCanvasImage(image, width, height) {
  var canvas = document.createElement('canvas');
  var context = null;
  canvas.width = width || image.naturalWidth;
  canvas.height = height || image.naturalHeight;
  context = canvas.getContext('2d');
  context.drawImage(image, 0, 0);
}

function getTexture(imageName) {

  return loader.load(__WEBPACK_IMPORTED_MODULE_1__assets_js_constants__["a" /* IMAGE_URLS */][imageName]);
}

function isSamePosition(position1, position2) {
  var accuracy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.01;

  return Math.abs(position1.x - position2.x) < accuracy && Math.abs(position1.y - position2.y) < accuracy && Math.abs(position1.z - position2.z) < accuracy;
}

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(197),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


!function (a, b) {
  "function" == typeof define && (__webpack_require__(210) || define.cmd) ? define(function () {
    return b(a);
  }) : b(a, !0);
}(window, function (a, b) {
  function c(b, c, d) {
    a.WeixinJSBridge ? WeixinJSBridge.invoke(b, e(c), function (a) {
      h(b, a, d);
    }) : k(b, d);
  }function d(b, c, d) {
    a.WeixinJSBridge ? WeixinJSBridge.on(b, function (a) {
      d && d.trigger && d.trigger(a), h(b, a, c);
    }) : d ? k(b, d) : k(b, c);
  }function e(a) {
    return a = a || {}, a.appId = D.appId, a.verifyAppId = D.appId, a.verifySignType = "sha1", a.verifyTimestamp = D.timestamp + "", a.verifyNonceStr = D.nonceStr, a.verifySignature = D.signature, a;
  }function f(a) {
    return { timeStamp: a.timestamp + "", nonceStr: a.nonceStr, "package": a["package"], paySign: a.paySign, signType: a.signType || "SHA1" };
  }function g(a) {
    return a.postalCode = a.addressPostalCode, delete a.addressPostalCode, a.provinceName = a.proviceFirstStageName, delete a.proviceFirstStageName, a.cityName = a.addressCitySecondStageName, delete a.addressCitySecondStageName, a.countryName = a.addressCountiesThirdStageName, delete a.addressCountiesThirdStageName, a.detailInfo = a.addressDetailInfo, delete a.addressDetailInfo, a;
  }function h(a, b, c) {
    "openEnterpriseChat" == a && (b.errCode = b.err_code), delete b.err_code, delete b.err_desc, delete b.err_detail;var d = b.errMsg;d || (d = b.err_msg, delete b.err_msg, d = i(a, d), b.errMsg = d), c = c || {}, c._complete && (c._complete(b), delete c._complete), d = b.errMsg || "", D.debug && !c.isInnerInvoke && alert(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(b));var e = d.indexOf(":"),
        f = d.substring(e + 1);switch (f) {case "ok":
        c.success && c.success(b);break;case "cancel":
        c.cancel && c.cancel(b);break;default:
        c.fail && c.fail(b);}c.complete && c.complete(b);
  }function i(a, b) {
    var c = a,
        d = q[c];d && (c = d);var e = "ok";if (b) {
      var f = b.indexOf(":");e = b.substring(f + 1), "confirm" == e && (e = "ok"), "failed" == e && (e = "fail"), -1 != e.indexOf("failed_") && (e = e.substring(7)), -1 != e.indexOf("fail_") && (e = e.substring(5)), e = e.replace(/_/g, " "), e = e.toLowerCase(), ("access denied" == e || "no permission to execute" == e) && (e = "permission denied"), "config" == c && "function not exist" == e && (e = "ok"), "" == e && (e = "fail");
    }return b = c + ":" + e;
  }function j(a) {
    if (a) {
      for (var b = 0, c = a.length; c > b; ++b) {
        var d = a[b],
            e = p[d];e && (a[b] = e);
      }return a;
    }
  }function k(a, b) {
    if (!(!D.debug || b && b.isInnerInvoke)) {
      var c = q[a];c && (a = c), b && b._complete && delete b._complete, console.log('"' + a + '",', b || "");
    }
  }function l(a) {
    if (!(v || w || D.debug || "6.0.2" > A || C.systemType < 0)) {
      var b = new Image();C.appId = D.appId, C.initTime = B.initEndTime - B.initStartTime, C.preVerifyTime = B.preVerifyEndTime - B.preVerifyStartTime, I.getNetworkType({ isInnerInvoke: !0, success: function success(a) {
          C.networkType = a.networkType;var c = "https://open.weixin.qq.com/sdk/report?v=" + C.version + "&o=" + C.isPreVerifyOk + "&s=" + C.systemType + "&c=" + C.clientVersion + "&a=" + C.appId + "&n=" + C.networkType + "&i=" + C.initTime + "&p=" + C.preVerifyTime + "&u=" + C.url;b.src = c;
        } });
    }
  }function m() {
    return new Date().getTime();
  }function n(b) {
    x && (a.WeixinJSBridge ? b() : r.addEventListener && r.addEventListener("WeixinJSBridgeReady", b, !1));
  }function o() {
    I.invoke || (I.invoke = function (b, c, d) {
      a.WeixinJSBridge && WeixinJSBridge.invoke(b, e(c), d);
    }, I.on = function (b, c) {
      a.WeixinJSBridge && WeixinJSBridge.on(b, c);
    });
  }if (!a.jWeixin) {
    var _I;

    var p = { config: "preVerifyJSAPI", onMenuShareTimeline: "menu:share:timeline", onMenuShareAppMessage: "menu:share:appmessage", onMenuShareQQ: "menu:share:qq", onMenuShareWeibo: "menu:share:weiboApp", onMenuShareQZone: "menu:share:QZone", previewImage: "imagePreview", getLocation: "geoLocation", openProductSpecificView: "openProductViewWithPid", addCard: "batchAddCard", openCard: "batchViewCard", chooseWXPay: "getBrandWCPayRequest", openEnterpriseRedPacket: "getRecevieBizHongBaoRequest", startSearchBeacons: "startMonitoringBeacons", stopSearchBeacons: "stopMonitoringBeacons", onSearchBeacons: "onBeaconsInRange", consumeAndShareCard: "consumedShareCard", openAddress: "editAddress" },
        q = function () {
      var a = {};for (var b in p) {
        a[p[b]] = b;
      }return a;
    }(),
        r = a.document,
        s = r.title,
        t = navigator.userAgent.toLowerCase(),
        u = navigator.platform.toLowerCase(),
        v = !(!u.match("mac") && !u.match("win")),
        w = -1 != t.indexOf("wxdebugger"),
        x = -1 != t.indexOf("micromessenger"),
        y = -1 != t.indexOf("android"),
        z = -1 != t.indexOf("iphone") || -1 != t.indexOf("ipad"),
        A = function () {
      var a = t.match(/micromessenger\/(\d+\.\d+\.\d+)/) || t.match(/micromessenger\/(\d+\.\d+)/);return a ? a[1] : "";
    }(),
        B = { initStartTime: m(), initEndTime: 0, preVerifyStartTime: 0, preVerifyEndTime: 0 },
        C = { version: 1, appId: "", initTime: 0, preVerifyTime: 0, networkType: "", isPreVerifyOk: 1, systemType: z ? 1 : y ? 2 : -1, clientVersion: A, url: encodeURIComponent(location.href) },
        D = {},
        E = { _completes: [] },
        F = { state: 0, data: {} };n(function () {
      B.initEndTime = m();
    });var G = !1,
        H = [],
        I = (_I = { config: function config(a) {
        D = a, k("config", a);var b = D.check === !1 ? !1 : !0;n(function () {
          if (b) c(p.config, { verifyJsApiList: j(D.jsApiList) }, function () {
            E._complete = function (a) {
              B.preVerifyEndTime = m(), F.state = 1, F.data = a;
            }, E.success = function (a) {
              C.isPreVerifyOk = 0;
            }, E.fail = function (a) {
              E._fail ? E._fail(a) : F.state = -1;
            };var a = E._completes;return a.push(function () {
              l();
            }), E.complete = function (b) {
              for (var c = 0, d = a.length; d > c; ++c) {
                a[c]();
              }E._completes = [];
            }, E;
          }()), B.preVerifyStartTime = m();else {
            F.state = 1;for (var a = E._completes, d = 0, e = a.length; e > d; ++d) {
              a[d]();
            }E._completes = [];
          }
        }), D.beta && o();
      }, ready: function ready(a) {
        0 != F.state ? a() : (E._completes.push(a), !x && D.debug && a());
      }, error: function error(a) {
        "6.0.2" > A || (-1 == F.state ? a(F.data) : E._fail = a);
      }, checkJsApi: function checkJsApi(a) {
        var b = function b(a) {
          var b = a.checkResult;for (var c in b) {
            var d = q[c];d && (b[d] = b[c], delete b[c]);
          }return a;
        };c("checkJsApi", { jsApiList: j(a.jsApiList) }, function () {
          return a._complete = function (a) {
            if (y) {
              var c = a.checkResult;c && (a.checkResult = JSON.parse(c));
            }a = b(a);
          }, a;
        }());
      }, onMenuShareTimeline: function onMenuShareTimeline(a) {
        d(p.onMenuShareTimeline, { complete: function complete() {
            c("shareTimeline", { title: a.title || s, desc: a.title || s, img_url: a.imgUrl || "", link: a.link || location.href, type: a.type || "link", data_url: a.dataUrl || "" }, a);
          } }, a);
      }, onMenuShareAppMessage: function onMenuShareAppMessage(a) {
        d(p.onMenuShareAppMessage, { complete: function complete() {
            c("sendAppMessage", { title: a.title || s, desc: a.desc || "", link: a.link || location.href, img_url: a.imgUrl || "", type: a.type || "link", data_url: a.dataUrl || "" }, a);
          } }, a);
      }, onMenuShareQQ: function onMenuShareQQ(a) {
        d(p.onMenuShareQQ, { complete: function complete() {
            c("shareQQ", { title: a.title || s, desc: a.desc || "", img_url: a.imgUrl || "", link: a.link || location.href }, a);
          } }, a);
      }, onMenuShareWeibo: function onMenuShareWeibo(a) {
        d(p.onMenuShareWeibo, { complete: function complete() {
            c("shareWeiboApp", { title: a.title || s, desc: a.desc || "", img_url: a.imgUrl || "", link: a.link || location.href }, a);
          } }, a);
      }, onMenuShareQZone: function onMenuShareQZone(a) {
        d(p.onMenuShareQZone, { complete: function complete() {
            c("shareQZone", { title: a.title || s, desc: a.desc || "", img_url: a.imgUrl || "", link: a.link || location.href }, a);
          } }, a);
      }, startRecord: function startRecord(a) {
        c("startRecord", {}, a);
      }, stopRecord: function stopRecord(a) {
        c("stopRecord", {}, a);
      }, onVoiceRecordEnd: function onVoiceRecordEnd(a) {
        d("onVoiceRecordEnd", a);
      }, playVoice: function playVoice(a) {
        c("playVoice", { localId: a.localId }, a);
      }, pauseVoice: function pauseVoice(a) {
        c("pauseVoice", { localId: a.localId }, a);
      }, stopVoice: function stopVoice(a) {
        c("stopVoice", { localId: a.localId }, a);
      }, onVoicePlayEnd: function onVoicePlayEnd(a) {
        d("onVoicePlayEnd", a);
      }, uploadVoice: function uploadVoice(a) {
        c("uploadVoice", { localId: a.localId, isShowProgressTips: 0 == a.isShowProgressTips ? 0 : 1 }, a);
      }, downloadVoice: function downloadVoice(a) {
        c("downloadVoice", { serverId: a.serverId, isShowProgressTips: 0 == a.isShowProgressTips ? 0 : 1 }, a);
      }, translateVoice: function translateVoice(a) {
        c("translateVoice", { localId: a.localId, isShowProgressTips: 0 == a.isShowProgressTips ? 0 : 1 }, a);
      }, chooseImage: function chooseImage(a) {
        c("chooseImage", { scene: "1|2", count: a.count || 9, sizeType: a.sizeType || ["original", "compressed"], sourceType: a.sourceType || ["album", "camera"] }, function () {
          return a._complete = function (a) {
            if (y) {
              var b = a.localIds;b && (a.localIds = JSON.parse(b));
            }
          }, a;
        }());
      }, getLocation: function getLocation(a) {}, previewImage: function previewImage(a) {
        c(p.previewImage, { current: a.current, urls: a.urls }, a);
      }, uploadImage: function uploadImage(a) {
        c("uploadImage", { localId: a.localId, isShowProgressTips: 0 == a.isShowProgressTips ? 0 : 1 }, a);
      }, downloadImage: function downloadImage(a) {
        c("downloadImage", { serverId: a.serverId, isShowProgressTips: 0 == a.isShowProgressTips ? 0 : 1 }, a);
      }, getLocalImgData: function getLocalImgData(a) {
        G === !1 ? (G = !0, c("getLocalImgData", { localId: a.localId }, function () {
          return a._complete = function (a) {
            if (G = !1, H.length > 0) {
              var b = H.shift();wx.getLocalImgData(b);
            }
          }, a;
        }())) : H.push(a);
      }, getNetworkType: function getNetworkType(a) {
        var b = function b(a) {
          var b = a.errMsg;a.errMsg = "getNetworkType:ok";var c = a.subtype;if (delete a.subtype, c) a.networkType = c;else {
            var d = b.indexOf(":"),
                e = b.substring(d + 1);switch (e) {case "wifi":case "edge":case "wwan":
                a.networkType = e;break;default:
                a.errMsg = "getNetworkType:fail";}
          }return a;
        };c("getNetworkType", {}, function () {
          return a._complete = function (a) {
            a = b(a);
          }, a;
        }());
      }, openLocation: function openLocation(a) {
        c("openLocation", { latitude: a.latitude, longitude: a.longitude, name: a.name || "", address: a.address || "", scale: a.scale || 28, infoUrl: a.infoUrl || "" }, a);
      } }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "getLocation", function getLocation(a) {
      a = a || {}, c(p.getLocation, { type: a.type || "wgs84" }, function () {
        return a._complete = function (a) {
          delete a.type;
        }, a;
      }());
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "hideOptionMenu", function hideOptionMenu(a) {
      c("hideOptionMenu", {}, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "showOptionMenu", function showOptionMenu(a) {
      c("showOptionMenu", {}, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "closeWindow", function closeWindow(a) {
      a = a || {}, c("closeWindow", {}, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "hideMenuItems", function hideMenuItems(a) {
      c("hideMenuItems", { menuList: a.menuList }, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "showMenuItems", function showMenuItems(a) {
      c("showMenuItems", { menuList: a.menuList }, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "hideAllNonBaseMenuItem", function hideAllNonBaseMenuItem(a) {
      c("hideAllNonBaseMenuItem", {}, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "showAllNonBaseMenuItem", function showAllNonBaseMenuItem(a) {
      c("showAllNonBaseMenuItem", {}, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "scanQRCode", function scanQRCode(a) {
      a = a || {}, c("scanQRCode", { needResult: a.needResult || 0, scanType: a.scanType || ["qrCode", "barCode"] }, function () {
        return a._complete = function (a) {
          if (z) {
            var b = a.resultStr;if (b) {
              var c = JSON.parse(b);a.resultStr = c && c.scan_code && c.scan_code.scan_result;
            }
          }
        }, a;
      }());
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "openAddress", function openAddress(a) {
      c(p.openAddress, {}, function () {
        return a._complete = function (a) {
          a = g(a);
        }, a;
      }());
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "openProductSpecificView", function openProductSpecificView(a) {
      c(p.openProductSpecificView, { pid: a.productId, view_type: a.viewType || 0, ext_info: a.extInfo }, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "addCard", function addCard(a) {
      for (var b = a.cardList, d = [], e = 0, f = b.length; f > e; ++e) {
        var g = b[e],
            h = { card_id: g.cardId, card_ext: g.cardExt };d.push(h);
      }c(p.addCard, { card_list: d }, function () {
        return a._complete = function (a) {
          var b = a.card_list;if (b) {
            b = JSON.parse(b);for (var c = 0, d = b.length; d > c; ++c) {
              var e = b[c];e.cardId = e.card_id, e.cardExt = e.card_ext, e.isSuccess = e.is_succ ? !0 : !1, delete e.card_id, delete e.card_ext, delete e.is_succ;
            }a.cardList = b, delete a.card_list;
          }
        }, a;
      }());
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "chooseCard", function chooseCard(a) {
      c("chooseCard", { app_id: D.appId, location_id: a.shopId || "", sign_type: a.signType || "SHA1", card_id: a.cardId || "", card_type: a.cardType || "", card_sign: a.cardSign, time_stamp: a.timestamp + "", nonce_str: a.nonceStr }, function () {
        return a._complete = function (a) {
          a.cardList = a.choose_card_info, delete a.choose_card_info;
        }, a;
      }());
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "openCard", function openCard(a) {
      for (var b = a.cardList, d = [], e = 0, f = b.length; f > e; ++e) {
        var g = b[e],
            h = { card_id: g.cardId, code: g.code };d.push(h);
      }c(p.openCard, { card_list: d }, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "consumeAndShareCard", function consumeAndShareCard(a) {
      c(p.consumeAndShareCard, { consumedCardId: a.cardId, consumedCode: a.code }, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "chooseWXPay", function chooseWXPay(a) {
      c(p.chooseWXPay, f(a), a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "openEnterpriseRedPacket", function openEnterpriseRedPacket(a) {
      c(p.openEnterpriseRedPacket, f(a), a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "startSearchBeacons", function startSearchBeacons(a) {
      c(p.startSearchBeacons, { ticket: a.ticket }, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "stopSearchBeacons", function stopSearchBeacons(a) {
      c(p.stopSearchBeacons, {}, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "onSearchBeacons", function onSearchBeacons(a) {
      d(p.onSearchBeacons, a);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_I, "openEnterpriseChat", function openEnterpriseChat(a) {
      c("openEnterpriseChat", { useridlist: a.userIds, chatname: a.groupName }, a);
    }), _I),
        J = 1,
        K = {};return r.addEventListener("error", function (a) {
      if (!y) {
        var b = a.target,
            c = b.tagName,
            d = b.src;if ("IMG" == c || "VIDEO" == c || "AUDIO" == c || "SOURCE" == c) {
          var e = -1 != d.indexOf("wxlocalresource://");if (e) {
            a.preventDefault(), a.stopPropagation();var f = b["wx-id"];if (f || (f = J++, b["wx-id"] = f), K[f]) return;K[f] = !0, wx.ready(function () {
              wx.getLocalImgData({ localId: d, success: function success(a) {
                  b.src = a.localData;
                } });
            });
          }
        }
      }
    }, !0), r.addEventListener("load", function (a) {
      if (!y) {
        var b = a.target,
            c = b.tagName;b.src;if ("IMG" == c || "VIDEO" == c || "AUDIO" == c || "SOURCE" == c) {
          var d = b["wx-id"];d && (K[d] = !1);
        }
      }
    }, !0), b && (a.wx = a.jWeixin = I), I;
  }
});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(207),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tween_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_tween_js__);









var BaseState = function () {
  function BaseState(controller) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, BaseState);

    this.controller = controller;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(BaseState, [{
    key: 'forward',
    value: function forward() {}
  }, {
    key: 'backward',
    value: function backward() {}
  }]);

  return BaseState;
}();

var EnteringState = function (_BaseState) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(EnteringState, _BaseState);

  function EnteringState(controller) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, EnteringState);

    var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EnteringState.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(EnteringState)).call(this, controller));

    _this.tween = new __WEBPACK_IMPORTED_MODULE_7_tween_js___default.a.Tween({
      x: 3.55, y: 0, z: -328, ry: 0
    }).to({
      x: 0, y: 0, z: -28, ry: Math.PI * -2
    }, 1600).onUpdate(function () {
      controller.earth.setCamera(this.x, this.y, this.z);
      controller.earth.earthGroup.rotation.y = this.ry;
    }).onComplete(function () {
      controller.changeState('idle');
    }).easing(__WEBPACK_IMPORTED_MODULE_7_tween_js___default.a.Easing.Cubic.Out).start();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(EnteringState, [{
    key: 'forward',
    value: function forward() {
      __WEBPACK_IMPORTED_MODULE_7_tween_js___default.a.update();
    }
  }]);

  return EnteringState;
}(BaseState);

var IdleState = function (_BaseState2) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(IdleState, _BaseState2);

  function IdleState(controller) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, IdleState);

    var _this2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IdleState.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(IdleState)).call(this, controller));

    if (!(controller.state instanceof EnteringState)) {
      controller.playSprite('audio');
    }

    controller.earth.controller.enabled = true;
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(IdleState, [{
    key: 'forward',
    value: function forward() {
      this.controller.changeState('rotating');
    }
  }]);

  return IdleState;
}(BaseState);

var RotatingState = function (_BaseState3) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(RotatingState, _BaseState3);

  function RotatingState(controller) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RotatingState);

    var _this3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RotatingState.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RotatingState)).call(this, controller));

    _this3.tween = null;
    controller.pauseSprite('audio');
    controller.earth.controller.enabled = false;
    return _this3;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RotatingState, [{
    key: 'forward',
    value: function forward() {
      var that = this;
      var earth = this.controller.earth;
      var target = this.controller.target;

      if (this.tween) {
        __WEBPACK_IMPORTED_MODULE_7_tween_js___default.a.update();
      } else {
        this.tween = new __WEBPACK_IMPORTED_MODULE_7_tween_js___default.a.Tween(earth.cameraPosition()).to({
          x: target.cameraFarPosition[0],
          y: target.cameraFarPosition[1],
          z: target.cameraFarPosition[2]
        }, 1000).onUpdate(function () {
          earth.setCamera(this.x, this.y, this.z);
        }).onComplete(function () {
          that.controller.changeState('zooming');
          that.tween = null;
        }).start();
      }
    }
  }, {
    key: 'backward',
    value: function backward() {
      if (this.tween) {
        __WEBPACK_IMPORTED_MODULE_7_tween_js___default.a.update();
      } else {
        this.controller.state = new IdleState(this.controller);
      }
    }
  }]);

  return RotatingState;
}(BaseState);

var ZoomingState = function (_BaseState4) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ZoomingState, _BaseState4);

  function ZoomingState(controller) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ZoomingState);

    var _this4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ZoomingState.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ZoomingState)).call(this, controller));

    _this4.direction = '';
    _this4.tween = null;
    controller.hideCloud();
    controller.showEarth();
    return _this4;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ZoomingState, [{
    key: '_setDirection',
    value: function _setDirection(direction) {
      var that = this;
      var earth = this.controller.earth;
      var target = this.controller.target;
      var from = earth.cameraPosition();
      var to = null;

      if (this.direction !== direction) {
        if (direction === 'forward') {
          to = {
            x: target.cameraNearPosition[0],
            y: target.cameraNearPosition[1],
            z: target.cameraNearPosition[2]
          };
        } else {
          to = {
            x: target.cameraFarPosition[0],
            y: target.cameraFarPosition[1],
            z: target.cameraFarPosition[2]
          };
        }

        this.direction = direction;
        this.tween && this.tween.stop();

        this.tween = new __WEBPACK_IMPORTED_MODULE_7_tween_js___default.a.Tween(from).to(to, 1000).onUpdate(function () {
          earth.setCamera(this.x, this.y, this.z);
        }).onComplete(function () {
          that._handleTweenComplete();
        }).start();
      }
    }
  }, {
    key: '_handleTweenComplete',
    value: function _handleTweenComplete() {
      if (this.direction === 'forward') {
        this.controller.changeState('diving');
      } else {
        this.controller.changeState('idle');
      }
      this.tween = null;
    }
  }, {
    key: 'forward',
    value: function forward() {
      this._setDirection('forward');
      if (this.tween) {
        __WEBPACK_IMPORTED_MODULE_7_tween_js___default.a.update();
      }
    }
  }, {
    key: 'backward',
    value: function backward() {
      this._setDirection('backward');
      if (this.tween) {
        __WEBPACK_IMPORTED_MODULE_7_tween_js___default.a.update();
      }
    }
  }]);

  return ZoomingState;
}(BaseState);

var DivingState = function (_BaseState5) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DivingState, _BaseState5);

  function DivingState(controller) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DivingState);

    var _this5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DivingState.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DivingState)).call(this, controller));

    _this5.count = 0;
    controller.showCloud();
    controller.hideEarth();
    controller.hideVideo();
    return _this5;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(DivingState, [{
    key: '_throttle',
    value: function _throttle(fn) {
      if (this.count % 3 === 0) {
        fn && fn();
        this.count = 0;
      }
      this.count++;
    }
  }, {
    key: 'forward',
    value: function forward() {
      var cloud = this.controller.cloud;
      if (cloud.currentFrameIndex === cloud.images.length - 1) {
        this.controller.changeState('presenting');
      } else {
        this._throttle(function (_) {
          return cloud.next();
        });
      }
    }
  }, {
    key: 'backward',
    value: function backward() {
      var cloud = this.controller.cloud;
      if (cloud.currentFrameIndex === 0) {
        this.controller.changeState('zooming');
      } else {
        this._throttle(function (_) {
          return cloud.prev();
        });
      }
    }
  }]);

  return DivingState;
}(BaseState);

var PresentingState = function (_BaseState6) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PresentingState, _BaseState6);

  function PresentingState(controller) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PresentingState);

    var _this6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PresentingState.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PresentingState)).call(this, controller));

    controller.hideCloud();
    controller.showVideo();
    return _this6;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PresentingState, [{
    key: 'backward',
    value: function backward() {
      this.controller.changeState('diving');
    }
  }]);

  return PresentingState;
}(BaseState);

var Controller = function () {
  function Controller(options) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Controller);

    this.earth = options.earth;
    this.cloud = options.cloud;
    this.audioSprite = options.audioSprite;
    this.videoSprite = options.videoSprite;
    this.onStateChange = options.onStateChange;
    this.onTargetChange = options.onTargetChange;

    this.state = null;
    this.touchDown = false;

    this.target = null;
    this.targetList = [];

    this._init();
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Controller, [{
    key: '_init',
    value: function _init() {
      var _this7 = this;

      setTimeout(function (_) {
        _this7.state = new EnteringState(_this7);
      }, 800);
      this._shuffleTargetList();
      this._loop();
    }
  }, {
    key: '_shuffleTargetList',
    value: function _shuffleTargetList() {
      this.targetList = __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default()(__WEBPACK_IMPORTED_MODULE_5__assets_js_constants__["c" /* LOCATIONS */].map(function (location) {
        return location.name;
      }));
    }
  }, {
    key: '_loop',
    value: function _loop() {
      requestAnimationFrame(this._loop.bind(this));
      this._animate();
    }
  }, {
    key: '_animate',
    value: function _animate() {
      if (!this.state) {
        return;
      }

      if (this.state instanceof EnteringState) {
        this.state.forward();
      }

      if (this.touchDown && this.target) {
        this.state.forward();
      } else {
        this.state.backward();
      }
    }
  }, {
    key: 'showEarth',
    value: function showEarth() {
      this.earth.container.style.display = 'block';
    }
  }, {
    key: 'hideEarth',
    value: function hideEarth() {
      this.earth.container.style.display = 'none';
    }
  }, {
    key: 'showCloud',
    value: function showCloud() {
      this.cloud.el.style.display = 'block';
    }
  }, {
    key: 'hideCloud',
    value: function hideCloud() {
      this.cloud.el.style.display = 'none';
    }
  }, {
    key: 'showVideo',
    value: function showVideo() {
      this.playSprite('video');
      this.videoSprite.media.style.display = 'block';
    }
  }, {
    key: 'hideVideo',
    value: function hideVideo() {
      this.pauseSprite('video');
      this.videoSprite.media.style.display = 'none';
    }
  }, {
    key: 'playSprite',
    value: function playSprite(type) {
      if (!this.target) {
        return;
      }

      if (type === 'video') {
        this.videoSprite.repeat(this.target.name);
      } else if (type === 'audio') {
        this.audioSprite.play(this.target.name);
      }
    }
  }, {
    key: 'pauseSprite',
    value: function pauseSprite(type) {
      if (type === 'video') {
        this.videoSprite.pause();
      } else if (type === 'audio') {
        this.audioSprite.pause();
      }
    }
  }, {
    key: 'start',
    value: function start() {
      this.touchDown = true;
    }
  }, {
    key: 'end',
    value: function end() {
      this.touchDown = false;
    }
  }, {
    key: 'nextTarget',
    value: function nextTarget() {
      var nextTargetIndex = (this.targetList.indexOf(this.target ? this.target.name : null) + 1) % this.targetList.length;
      this.setTarget(this.targetList[nextTargetIndex]);
    }
  }, {
    key: 'setTarget',
    value: function setTarget(locationName) {
      this.target = __WEBPACK_IMPORTED_MODULE_5__assets_js_constants__["c" /* LOCATIONS */].filter(function (location) {
        return location.name === locationName;
      })[0];
      this.playSprite('audio');
      this.videoSprite.set(locationName);
      this.onTargetChange && this.onTargetChange();
    }
  }, {
    key: 'changeState',
    value: function changeState(stateName) {
      switch (stateName) {
        case 'idle':
          this.state = new IdleState(this);
          break;
        case 'rotating':
          this.state = new RotatingState(this);
          break;
        case 'zooming':
          this.state = new ZoomingState(this);
          break;
        case 'diving':
          this.state = new DivingState(this);
          break;
        case 'presenting':
          this.state = new PresentingState(this);
          break;
        default:
          this.state = new BaseState(this);
      }
      this.onStateChange && this.onStateChange(stateName);
    }
  }]);

  return Controller;
}();

/* harmony default export */ __webpack_exports__["a"] = (Controller);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCloud;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_utils__ = __webpack_require__(24);



function createCloud() {
  return new __WEBPACK_IMPORTED_MODULE_0_three__["Mesh"](new __WEBPACK_IMPORTED_MODULE_0_three__["SphereGeometry"](5.2, 40, 40), new __WEBPACK_IMPORTED_MODULE_0_three__["MeshPhongMaterial"]({
    map: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_utils__["a" /* getTexture */])('earthCloud'),
    transparent: true,
    opacity: 1,
    blending: __WEBPACK_IMPORTED_MODULE_0_three__["AdditiveBlending"]
  }));
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEarth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_utils__ = __webpack_require__(24);



function createEarth() {
  return new __WEBPACK_IMPORTED_MODULE_0_three__["Mesh"](new __WEBPACK_IMPORTED_MODULE_0_three__["SphereGeometry"](5, 32, 32), new __WEBPACK_IMPORTED_MODULE_0_three__["MeshPhongMaterial"]({
    map: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_utils__["a" /* getTexture */])('earth'),
    bumpMap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_utils__["a" /* getTexture */])('earthBump'),
    bumpScale: 0.15,
    specularMap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_utils__["a" /* getTexture */])('earthSpec'),
    specular: new __WEBPACK_IMPORTED_MODULE_0_three__["Color"]('#909090'),
    shininess: 5,
    transparent: true
  }));
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AdditiveBlendShader; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createOuterGlow;
/* unused harmony export createBlack */
/* unused harmony export createGlow */
/* unused harmony export createFlowMaterial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(7);


var vertexShader = ['varying vec3 vNormal;', 'void main() {', 'vNormal = normalize( normalMatrix * normal );', 'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );', '}'].join('\n');
var fragmentShader = ['uniform float c;', 'uniform float p;', 'varying vec3 vNormal;', 'void main() {', 'float intensity = pow( c - dot( vNormal, vec3( 0.0, 0.0, 1.0 ) ), p );', 'gl_FragColor = vec4( 0.2, 0.58, 0.9, 0.3 ) * intensity;', '}'].join('\n');

var AdditiveBlendShader = {
  uniforms: {
    'tSampler1': { type: 't', value: null },
    'tSampler2': { type: 't', value: null }
  },
  vertexShader: ['varying vec2 vUv;', 'void main() {', 'vUv = uv;', 'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );', '}'].join('\n'),
  fragmentShader: ['uniform sampler2D tSampler1;', 'uniform sampler2D tSampler2;', 'varying vec2 vUv;', 'void main() {', 'vec4 texture1 = texture2D( tSampler1, vUv );', 'vec4 texture2 = texture2D( tSampler2, vUv );', 'gl_FragColor = texture1 + texture2;', '}'].join('\n')
};

function createOuterGlow() {
  var glowGroup = new __WEBPACK_IMPORTED_MODULE_0_three__["Group"]();
  glowGroup.add(createGlow());
  glowGroup.add(createBlack());
  return glowGroup;
}

function createBlack() {
  var sphere = new __WEBPACK_IMPORTED_MODULE_0_three__["SphereGeometry"](5, 40, 40);
  var blackMaterial = new __WEBPACK_IMPORTED_MODULE_0_three__["MeshBasicMaterial"]({ color: 0x000000 });
  var blackSphere = new __WEBPACK_IMPORTED_MODULE_0_three__["Mesh"](sphere, blackMaterial);
  blackSphere.material.transparent = false;
  return blackSphere;
}

function createGlow() {
  var sphere = new __WEBPACK_IMPORTED_MODULE_0_three__["SphereGeometry"](5, 40, 40);
  var material = createFlowMaterial();
  var glowSphere = new __WEBPACK_IMPORTED_MODULE_0_three__["Mesh"](sphere, material);
  glowSphere.material.side = __WEBPACK_IMPORTED_MODULE_0_three__["BackSide"];
  glowSphere.material.transparent = false;
  glowSphere.scale.x = glowSphere.scale.y = glowSphere.scale.z = 1.3;
  return glowSphere;
}

function createFlowMaterial() {
  var material = new __WEBPACK_IMPORTED_MODULE_0_three__["ShaderMaterial"]({
    uniforms: {
      'c': { type: 'f', value: 0.34 },
      'p': { type: 'f', value: 9.17 }
    },
    vertexShader: vertexShader,
    fragmentShader: fragmentShader
  });
  return material;
}

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glow__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lights__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__earth__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cloud__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locations__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_constants__ = __webpack_require__(1);


var THREE = __webpack_require__(7);
var OrbitControls = __webpack_require__(158)(THREE);
var EffectComposer = __webpack_require__(153)(THREE);








var WIDTH = __WEBPACK_IMPORTED_MODULE_7__assets_js_constants__["d" /* PAGE_WIDTH */];
var HEIGHT = __WEBPACK_IMPORTED_MODULE_7__assets_js_constants__["e" /* PAGE_HEIGHT */];

var Earth = function () {
  function Earth(el, options) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Earth);

    this.container = typeof el === 'string' ? document.getElementById(el) : el;

    this.width = WIDTH * 2;
    this.height = HEIGHT * 2;
    this.camera = null;
    this.renderer = null;
    this.controller = null;

    this.scene = null;
    this.earthGroup = null;
    this.locationGroup = null;
    this.cloud = null;
    this.hasGlow = false;

    this.autoRotate = true;
    this.rotationSpeed = 0.001;
    this.cloudSpeed = -0.0003;

    this._init();
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Earth, [{
    key: '_init',
    value: function _init() {
      this._createRenderer();
      this._createScene();
      this._createCamera();
      this._createLight();
      this._createEarth();
      this._createCloud();
      this._createLocations();
      this._createOutGlow();
      this._createController();

      this._loop();
    }
  }, {
    key: '_createController',
    value: function _createController() {
      var controller = new OrbitControls(this.camera);
      controller.rotateSpeed = 0.3;
      controller.autoRotate = false;
      controller.enableZoom = false;
      controller.enablePan = false;
      controller.enabled = true;
      this.controller = controller;
    }
  }, {
    key: '_createCamera',
    value: function _createCamera() {
      var camera = new THREE.PerspectiveCamera(40, this.width / this.height, 0.1, 1000);

      camera.position.set(3.55, 0, -328);
      this.scene.add(camera);
      this.camera = camera;
    }
  }, {
    key: '_createLight',
    value: function _createLight() {
      this.scene.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lights__["a" /* createAmbientLight */])());
      this.camera.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lights__["b" /* createSpotLight */])());
    }
  }, {
    key: '_createScene',
    value: function _createScene() {
      this.scene = new THREE.Scene();
      this.earthGroup = new THREE.Group();
      this.locationGroup = new THREE.Group();

      this.scene.add(this.earthGroup);
      this.earthGroup.add(this.locationGroup);
    }
  }, {
    key: '_createEarth',
    value: function _createEarth() {
      var earth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__earth__["a" /* createEarth */])();
      this.earthGroup.add(earth);
    }
  }, {
    key: '_createCloud',
    value: function _createCloud() {
      var cloud = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cloud__["a" /* createCloud */])();
      this.earthGroup.add(cloud);
      this.cloud = cloud;
    }
  }, {
    key: '_createLocations',
    value: function _createLocations() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_7__assets_js_constants__["c" /* LOCATIONS */].forEach(function (location) {
        var sprite = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__locations__["a" /* createLocationSprite */])(location);
        _this.locationGroup.add(sprite);
      });
    }
  }, {
    key: '_createRenderer',
    value: function _createRenderer() {
      var renderer = new THREE.WebGLRenderer({
        alpha: true,
        antialias: true,
        preserveDrawingBuffer: true
      });
      var container = this.container;

      renderer.setClearColor(0x000000, 0);

      renderer.setSize(this.width, this.height);
      renderer.domElement.style.position = 'relative';
      renderer.domElement.style.width = this.width / 2 + 'px';
      renderer.domElement.style.height = this.height / 2 + 'px';
      container.appendChild(renderer.domElement);
      this.renderer = renderer;
    }
  }, {
    key: '_createOutGlow',
    value: function _createOutGlow() {
      this.blurScene = new THREE.Scene();
      this.glowGroup = __WEBPACK_IMPORTED_MODULE_2__glow__["a" /* createOuterGlow */]();
      this.blurScene.add(this.glowGroup);

      var blurRenderTarget = new THREE.WebGLRenderTarget(this.width, this.height, {
        minFilter: THREE.LinearFilter,
        magFilter: THREE.LinearFilter,
        format: THREE.RGBAFormat,
        stencilBuffer: true
      });

      var blurRenderPass = new EffectComposer.RenderPass(this.blurScene, this.camera);
      var sceneRenderPass = new EffectComposer.RenderPass(this.scene, this.camera);

      this.blurComposer = new EffectComposer(this.renderer, blurRenderTarget);
      this.blurComposer.addPass(blurRenderPass);
      this.sceneComposer = new EffectComposer(this.renderer, blurRenderTarget);
      this.sceneComposer.addPass(sceneRenderPass);

      var effectBlend = new EffectComposer.ShaderPass(__WEBPACK_IMPORTED_MODULE_2__glow__["b" /* AdditiveBlendShader */], 'tSampler1');
      effectBlend.uniforms['tSampler2'].value = this.blurComposer.renderTarget2.texture;
      effectBlend.renderToScreen = true;

      this.sceneComposer.addPass(effectBlend);
      this.hasGlow = true;
    }
  }, {
    key: '_loop',
    value: function _loop() {
      requestAnimationFrame(this._loop.bind(this));
      this._animate();
      this._render();
    }
  }, {
    key: '_animate',
    value: function _animate() {
      var rotationSpeed = this.rotationSpeed;
      var cloudSpeed = this.cloudSpeed;

      if (this.autoRotate) {
        this.camera.position.x = this.camera.position.x * Math.cos(rotationSpeed) - this.camera.position.z * Math.sin(rotationSpeed);
        this.camera.position.z = this.camera.position.z * Math.cos(rotationSpeed) + this.camera.position.x * Math.sin(rotationSpeed);
      }

      this.cloud.rotation.y += cloudSpeed;
      this.controller.update();
    }
  }, {
    key: '_render',
    value: function _render() {
      if (this.isStart && this.hasGlow) {
        this.blurComposer.render();
        this.sceneComposer.render();
      } else {
        this.renderer.render(this.scene, this.camera);
        this.isStart = true;
      }
    }
  }, {
    key: 'setCamera',
    value: function setCamera() {
      if (arguments.length === 3) {
        this.camera.position.set(arguments[0], arguments[1], arguments[2]);
      } else {
        this.camera.position.set(arguments[0].x, arguments[0].y, arguments[0].z);
      }
    }
  }, {
    key: 'cameraPosition',
    value: function cameraPosition() {
      return {
        x: this.camera.position.x,
        y: this.camera.position.y,
        z: this.camera.position.z
      };
    }
  }, {
    key: 'startAutoRotate',
    value: function startAutoRotate() {
      this.autoRotate = true;
    }
  }, {
    key: 'stopAutoRotate',
    value: function stopAutoRotate() {
      this.autoRotate = false;
    }
  }]);

  return Earth;
}();

/* harmony default export */ __webpack_exports__["a"] = (Earth);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAmbientLight;
/* harmony export (immutable) */ __webpack_exports__["b"] = createSpotLight;
/* unused harmony export createDirectionalLight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(7);


function createAmbientLight() {
  return new __WEBPACK_IMPORTED_MODULE_0_three__["AmbientLight"](0x393939, 0.5);
}

function createSpotLight() {
  var spotLight = new __WEBPACK_IMPORTED_MODULE_0_three__["SpotLight"](0xffffff, 1.2);
  spotLight.position.set(-26, 11, -11);
  spotLight.angle = 0.2;
  spotLight.castShadow = false;
  spotLight.penumbra = 0.4;
  spotLight.distance = 124;
  spotLight.decay = 1;
  spotLight.shadow.camera.near = 50;
  spotLight.shadow.camera.far = 200;
  spotLight.shadow.camera.fov = 35;
  spotLight.shadow.mapSize.height = 1024;
  spotLight.shadow.mapSize.width = 1024;
  return spotLight;
}

function createDirectionalLight() {
  var light = new __WEBPACK_IMPORTED_MODULE_0_three__["DirectionalLight"](0xffffff, 1);
  light.position.set(5, 3, 5);
  return light;
}

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLocationSprite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_utils__ = __webpack_require__(24);



function createLocationSprite(location) {
  var spriteMaterial = new __WEBPACK_IMPORTED_MODULE_0_three__["SpriteMaterial"]({
    map: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_utils__["a" /* getTexture */])(location.imageName),
    color: 0xffffff,
    fog: true
  });
  var sprite = new __WEBPACK_IMPORTED_MODULE_0_three__["Sprite"](spriteMaterial);
  sprite.position.set(location.position[0], location.position[1], location.position[2]);
  sprite.scale.set(1.4, 1.4, 1.4);
  return sprite;
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_random__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_random__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_samplesize__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_samplesize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_samplesize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_constants__ = __webpack_require__(1);






var RANGE_TOTAL_STARS = [50, 100];
var RANGE_STAR_RADIUS = [1, 3];

var Meteor = function () {
  function Meteor(el) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Meteor);

    this.el = el;
    this.meteorImage = null;
    this.width = window.innerWidth * 2;
    this.height = window.innerHeight * 2;
    this.context = null;

    this.stars = [];
    this.meteor = null;

    this._init();
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Meteor, [{
    key: '_init',
    value: function _init() {
      this._loadImage();
      this._createCanvas();
      this._createStars();
      this._loop();
    }
  }, {
    key: '_loop',
    value: function _loop() {
      requestAnimationFrame(this._loop.bind(this));

      this._shine();
      this._moveMeteor();
      this._render();
    }
  }, {
    key: '_render',
    value: function _render() {
      this._clear();
      this._drawStars();

      if (this.meteor && this.meteorImage) {
        this._drawMeteor();
      }
    }
  }, {
    key: '_loadImage',
    value: function _loadImage() {
      var image = new Image();
      image.src = __WEBPACK_IMPORTED_MODULE_4__assets_js_constants__["a" /* IMAGE_URLS */].meteor;
      this.meteorImage = image;
    }
  }, {
    key: '_createCanvas',
    value: function _createCanvas() {
      var canvas = document.createElement('canvas');
      canvas.width = this.width;
      canvas.height = this.height;
      canvas.style.width = this.width / 2 + 'px';
      canvas.style.height = this.height / 2 + 'px';

      this.el.appendChild(canvas);
      this.context = canvas.getContext('2d');
    }
  }, {
    key: '_createStars',
    value: function _createStars() {
      var total = __WEBPACK_IMPORTED_MODULE_2_lodash_random___default.a.apply(null, RANGE_TOTAL_STARS);
      var width = this.width;
      var height = this.height;

      for (var i = 0; i < total; i++) {
        this.stars.push({
          x: __WEBPACK_IMPORTED_MODULE_2_lodash_random___default()(0, width),
          y: __WEBPACK_IMPORTED_MODULE_2_lodash_random___default()(0, height),
          r: __WEBPACK_IMPORTED_MODULE_2_lodash_random___default.a.apply(null, RANGE_STAR_RADIUS),
          shine: false
        });
      }
    }
  }, {
    key: '_clear',
    value: function _clear() {
      this.context.clearRect(0, 0, this.width, this.height);
    }
  }, {
    key: '_shine',
    value: function _shine() {
      var shineStar = __WEBPACK_IMPORTED_MODULE_3_lodash_samplesize___default()(this.stars, __WEBPACK_IMPORTED_MODULE_2_lodash_random___default()(this.stars.length * 0.9, this.stars.length));
      this.stars.forEach(function (star) {
        if (shineStar.indexOf(star) === -1) {
          star.shine = false;
        } else {
          star.shine = true;
        }
      });
    }
  }, {
    key: '_drawStars',
    value: function _drawStars() {
      var _this = this;

      this.stars.forEach(function (star) {
        _this._drawStar(star);
      });
    }
  }, {
    key: '_drawStar',
    value: function _drawStar(star) {
      var context = this.context;

      context.globalAlpha = 0.2;
      context.fillStyle = '#FFF';
      context.beginPath();
      context.arc(star.x, star.y, star.r, 0, Math.PI * 2, true);
      context.closePath();
      context.fill();

      if (star.shine) {
        context.globalAlpha = __WEBPACK_IMPORTED_MODULE_2_lodash_random___default()(0.5, 1);
        context.fillStyle = '#FFF';
        context.beginPath();
        context.arc(star.x, star.y, star.r * 0.8, 0, Math.PI * 2, true);
        context.closePath();
        context.fill();
      }
    }
  }, {
    key: '_drawMeteor',
    value: function _drawMeteor() {
      if (this.meteorImage.complete) {
        this.context.drawImage(this.meteorImage, this.meteor.x, this.meteor.y);
      }
    }
  }, {
    key: '_createMeteor',
    value: function _createMeteor() {
      var _this2 = this;

      setTimeout(function () {
        var startX = __WEBPACK_IMPORTED_MODULE_2_lodash_random___default()(_this2.width * 0.5, _this2.width * 1.5);
        var startY = __WEBPACK_IMPORTED_MODULE_2_lodash_random___default()(_this2.height * -0.5, _this2.height * 0.5);

        _this2.meteor = {
          x: startX,
          y: startY,
          fromX: startX,
          fromY: startY,
          toX: _this2.width * -0.1,
          toY: _this2.height * 1.1,
          speed: __WEBPACK_IMPORTED_MODULE_2_lodash_random___default()(2, 4)
        };
      }, __WEBPACK_IMPORTED_MODULE_2_lodash_random___default()(0, 1));
    }
  }, {
    key: '_moveMeteor',
    value: function _moveMeteor() {
      var meteor = this.meteor;
      if (!meteor) {
        this._createMeteor();
      } else {
        if (meteor.x < meteor.toX || meteor.y > meteor.toY) {
          this._createMeteor();
        } else {
          meteor.x -= meteor.speed;
          meteor.y += meteor.speed;
        }
      }
    }
  }]);

  return Meteor;
}();

/* harmony default export */ __webpack_exports__["a"] = (Meteor);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initWX;
/* unused harmony export configWX */
/* unused harmony export setShareInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_constants__ = __webpack_require__(1);

var JSAPI_CONFIG_URL = 'http://wx-service.yotta-tech.cn/jsapi/config';

function initWX() {
  fetch(JSAPI_CONFIG_URL + '?url=' + encodeURIComponent(window.location.href), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    mode: 'cors'
  }).then(function (r) {
    return r.json();
  }).then(function (r) {
    configWX(r.appId, r.timestamp, r.nonceStr, r.signature);
  });
}

function configWX(appId, timestamp, nonceStr, signature) {
  window.wx.config({
    debug: false,
    appId: appId,
    timestamp: timestamp,
    nonceStr: nonceStr,
    signature: signature,
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
  });

  setShareInfo();
}

function setShareInfo() {
  var title = '地球上最漂亮的H5';
  var link = 'http://xplan.jackyang.me';
  var imgUrl = __WEBPACK_IMPORTED_MODULE_0__assets_js_constants__["a" /* IMAGE_URLS */].wxShareImg;
  var wx = window.wx;

  wx.ready(function () {
    wx.onMenuShareTimeline({
      title: title,
      link: link,
      imgUrl: imgUrl
    });

    wx.onMenuShareAppMessage({
      title: title,
      desc: '这不是xplan官方链接，是来自外籍杰克的最强山寨版 -_-',
      link: link,
      imgUrl: imgUrl
    });
  });
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_jweixin_1_2_0__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

window.loader = null;

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_app_css__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_css_app_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_resource_loader__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_resource_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_resource_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Loading__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Show__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Show___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Show__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Meteor__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Meteor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Meteor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_BackgroundAudio__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_BackgroundAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_BackgroundAudio__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_3__views_Loading___default.a,
    'show': __WEBPACK_IMPORTED_MODULE_4__views_Show___default.a,
    'meteor': __WEBPACK_IMPORTED_MODULE_5__components_Meteor___default.a,
    'background-audio': __WEBPACK_IMPORTED_MODULE_7__components_BackgroundAudio___default.a
  },

  data: function data() {
    return {
      progress: 13,
      loading: true
    };
  },
  mounted: function mounted() {
    this.initLoader();
  },


  methods: {
    initLoader: function initLoader() {
      var _this = this;

      var loader = new __WEBPACK_IMPORTED_MODULE_2_resource_loader___default.a();

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__assets_js_constants__["a" /* IMAGE_URLS */]).forEach(function (name) {
        loader.add(name, __WEBPACK_IMPORTED_MODULE_6__assets_js_constants__["a" /* IMAGE_URLS */][name]);
      });

      loader.onProgress.add(function () {
        _this.progress = Math.round(loader.progress);
      });

      loader.onComplete.add(function () {
        setTimeout(function () {
          _this.loading = false;
        }, 500);
      });

      loader.load();
      window.loader = loader;
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_constants__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      audioSrc: __WEBPACK_IMPORTED_MODULE_0__assets_js_constants__["b" /* MEDIA_URLS */].backgroundAudio
    };
  },
  mounted: function mounted() {
    var el = this.$el;
    window.wx.ready(function () {
      el.play();
      el.pause();
      setTimeout(function (_) {
        return el.play();
      }, 0);
    });
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_meteor__ = __webpack_require__(72);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    new __WEBPACK_IMPORTED_MODULE_0__assets_js_meteor__["a" /* default */](this.$el);
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_page_css__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_page_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_css_page_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_center_it__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_center_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_center_it__);






/* harmony default export */ __webpack_exports__["default"] = ({
  wrapper: null,

  mounted: function mounted() {
    var _this = this;

    this.$options.wrapper = this.$refs.wrapper;
    window.addEventListener('resize', function () {
      _this.resize();
    });
    this.resize();
  },


  methods: {
    resize: function resize() {
      var $wrapper = this.$options.wrapper;
      var ratio = new __WEBPACK_IMPORTED_MODULE_2_center_it___default.a({
        containerWidth: window.innerWidth,
        containerHeight: window.innerHeight,
        originWidth: __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__["d" /* PAGE_WIDTH */],
        originHeight: __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__["e" /* PAGE_HEIGHT */],
        centerType: 'contain'
      }).ratio();
      $wrapper.style.transform = 'scale(' + ratio + ')';
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    showPressButton: Boolean,
    showXplanButton: Boolean
  },

  methods: {
    handleStart: function handleStart() {
      this.$emit('hold');
    },
    handleEnd: function handleEnd() {
      this.$emit('release');
    },
    handleClickXPlan: function handleClickXPlan() {
      this.$emit('knowmore');
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_media_sprite__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_media_sprite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_media_sprite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__ = __webpack_require__(1);





function getSpriteInfo() {
  var spriteInfo = {};
  __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__["c" /* LOCATIONS */].forEach(function (location) {
    spriteInfo[location.name] = location.soundSprite;
  });
  return spriteInfo;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  audioSprite: null,

  mounted: function mounted() {
    this.createAudioSprite();
  },


  methods: {
    createAudioSprite: function createAudioSprite() {
      var audioSprite = new __WEBPACK_IMPORTED_MODULE_0_media_sprite___default.a({
        media: __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__["b" /* MEDIA_URLS */].audioSprite,
        mediaType: 'audio',
        sprites: getSpriteInfo(),
        onReady: function onReady() {},

        onSpriteEnd: this.handleSpriteEnd.bind(this)
      });
      this.$options.audioSprite = audioSprite;

      window.wx.ready(function () {
        audioSprite.media.play();
        audioSprite.media.pause();
      });
    },
    handleSpriteEnd: function handleSpriteEnd() {
      this.$emit('spriteend');
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_image_sprite__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_image_sprite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_image_sprite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__ = __webpack_require__(1);





function getCloudImages(resources) {
  return new Array(13).fill('').map(function (item, index) {
    return resources['cloud' + index].data;
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  imageSprite: null,

  mounted: function mounted() {
    this.createImageSprite();
  },


  methods: {
    createImageSprite: function createImageSprite() {
      var images = getCloudImages(window.loader.resources);
      var imageSprite = new __WEBPACK_IMPORTED_MODULE_0_image_sprite___default.a(this.$refs.container, {
        interval: 80,
        width: __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__["d" /* PAGE_WIDTH */],
        height: __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__["e" /* PAGE_HEIGHT */],
        images: images
      });

      this.$options.imageSprite = imageSprite;
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    showTips: {
      type: Boolean,
      default: true
    },
    showCoord: {
      type: Boolean,
      default: true
    },
    coordIndex: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      backgroundPosition: ''
    };
  },


  watch: {
    coordIndex: function coordIndex(value) {
      this.setBackgroundPosition(value);
    }
  },

  methods: {
    setBackgroundPosition: function setBackgroundPosition(index) {
      this.backgroundPosition = ['0px 0px', '0px -19px', '0px -38px', '0px -57px', '0px -76px'][index];
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_earth__ = __webpack_require__(69);




/* harmony default export */ __webpack_exports__["default"] = ({
  earth: null,

  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var earth = new __WEBPACK_IMPORTED_MODULE_0__assets_js_earth__["a" /* default */](this.$refs.mountNode);
    this.$options.earth = earth;
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      active: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.active = true;
    }, 9000);
  },


  methods: {
    handleBack: function handleBack() {
      if (this.active) {
        this.$emit('back');
      }
    },
    handleRegister: function handleRegister() {
      if (this.active) {
        window.location.href = 'https://kandian.qq.com/mqq/activity/html/qqexplore.html';
      }
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_media_sprite__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_media_sprite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_media_sprite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__ = __webpack_require__(1);





function getSpriteInfo() {
  var spriteInfo = {};
  __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__["c" /* LOCATIONS */].forEach(function (location) {
    spriteInfo[location.name] = location.videoSprite;
  });
  return spriteInfo;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  videoSprite: null,

  data: function data() {
    return {
      videoSrc: __WEBPACK_IMPORTED_MODULE_1__assets_js_constants__["b" /* MEDIA_URLS */].videoSprite
    };
  },
  mounted: function mounted() {
    this.createVideoSprite();
  },


  methods: {
    createVideoSprite: function createVideoSprite() {
      var videoSprite = new __WEBPACK_IMPORTED_MODULE_0_media_sprite___default.a({
        media: this.$refs.video,
        mediaType: 'video',
        sprites: getSpriteInfo()
      });
      this.$options.videoSprite = videoSprite;

      window.wx.ready(function () {
        videoSprite.media.play();
        videoSprite.media.pause();
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_loading_css__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_css_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Page__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Page__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'page': __WEBPACK_IMPORTED_MODULE_1__components_Page___default.a
  },

  props: {
    progress: {
      type: Number,
      default: 0
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_show_css__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_show_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_css_show_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_wx__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_controller__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Page__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_show_Cover__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_show_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_show_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_show_EndCover__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_show_EndCover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_show_EndCover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_show_Earth__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_show_Earth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_show_Earth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_show_Clouds__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_show_Clouds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_show_Clouds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_show_VideoSprite__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_show_VideoSprite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_show_VideoSprite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_show_AudioSprite__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_show_AudioSprite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_show_AudioSprite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_show_Actions__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_show_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_show_Actions__);














/* harmony default export */ __webpack_exports__["default"] = ({
  controller: null,

  components: {
    'page': __WEBPACK_IMPORTED_MODULE_3__components_Page___default.a,
    'show-cover': __WEBPACK_IMPORTED_MODULE_4__components_show_Cover___default.a,
    'show-end-cover': __WEBPACK_IMPORTED_MODULE_5__components_show_EndCover___default.a,
    'show-earth': __WEBPACK_IMPORTED_MODULE_6__components_show_Earth___default.a,
    'show-clouds': __WEBPACK_IMPORTED_MODULE_7__components_show_Clouds___default.a,
    'show-video-sprite': __WEBPACK_IMPORTED_MODULE_8__components_show_VideoSprite___default.a,
    'show-audio-sprite': __WEBPACK_IMPORTED_MODULE_9__components_show_AudioSprite___default.a,
    'show-actions': __WEBPACK_IMPORTED_MODULE_10__components_show_Actions___default.a
  },

  data: function data() {
    return {
      isEnd: false,
      showTips: true,
      showCoord: false,
      showXplanButton: false,
      coordIndex: -1,
      revealed: false
    };
  },
  mounted: function mounted() {
    this.addDocumentTouchMove();
    this.createController();

    setTimeout(__WEBPACK_IMPORTED_MODULE_1__assets_js_wx__["a" /* initWX */], 300);
  },


  methods: {
    addDocumentTouchMove: function addDocumentTouchMove() {
      document.documentElement.addEventListener('touchmove', this.handleDocumentTouchMove.bind(this));
    },
    handleHold: function handleHold() {
      this.$options.controller.start();
    },
    handleRelease: function handleRelease() {
      this.$options.controller.end();
    },
    handleKnowMore: function handleKnowMore() {
      this.isEnd = true;
    },
    handleBack: function handleBack() {
      this.isEnd = false;
    },
    handleDocumentTouchMove: function handleDocumentTouchMove(e) {
      if (this.showTips) {
        this.showTips = false;
      }
      e.preventDefault();
    },
    handleAudioSpriteEnd: function handleAudioSpriteEnd() {
      this.$options.controller.nextTarget();
    },
    createController: function createController() {
      var that = this;
      var earth = this.$refs.earth.$options.earth;
      var cloudSprite = this.$refs.cloudSprite.$options.imageSprite;
      var videoSprite = this.$refs.videoSprite.$options.videoSprite;
      var audioSprite = this.$refs.audioSprite.$options.audioSprite;
      var controller = new __WEBPACK_IMPORTED_MODULE_2__assets_js_controller__["a" /* default */]({
        earth: earth,
        cloud: cloudSprite,
        videoSprite: videoSprite,
        audioSprite: audioSprite,
        onTargetChange: function onTargetChange() {
          that.showCoord = false;
        },
        onStateChange: function onStateChange(stateName) {
          if (stateName === 'idle') {
            that.showXplanButton = true;
          } else {
            that.showXplanButton = false;
          }
          if (stateName === 'zooming') {
            that.showCoord = true;
            that.coordIndex = controller.target.coordSpriteIndex;
          }
          if (stateName === 'presenting') {
            that.revealed = true;
          }
        }
      });
      setTimeout(function (_) {
        return controller.nextTarget();
      }, 1000);
      this.$options.controller = controller;
    }
  }
});

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/music_bg.6a58d58.mp3";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/music_sprite.8a28f11.mp3";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video_sprite.1ad92e6.mp4";

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/earth4.7cddb76.jpg";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/earth_bump.55b3930.jpg";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/earth_cloud.171481f.png";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/earth_spec.dc4fc60.jpg";

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAolBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8ELnaCAAAANXRSTlMAmSHdd2ZEEbu+7jPMJBhPA4gUB6uQQByNCp1pPSwvKKZuOA7KxbaxV5TCfdjQoYVdSuH25oWeqE0AAAQCSURBVHja7ZbXltowEEBHxb1gDKabNWBMb5v4/38tajhONpCHJeVh7jkgH8mSrkYjASAIgiAIgiAIgiAIgiAIgiAIgiAIgvwfpMulAx9wHPg73Na1wBvATxCiS5uBW0tsU891taixADiBTzKqDRwaOBGEIRFwKQCuBdR3GgHj5XdrxaccDnWD9UsB1eJaZqltgW0In48A/VI3yCUaLIHrym/xLCPQBWb/LED4CwQudYtpo1UzQ02B1H1gIYh26tYNrs18yvQz+4TAvi1QfBegFqOOb4kH8BmzWBg0SeB2XxmBU1vA/S5gWy4hzApqug2Z1a0tcp/K8ZkRCHxay1rX+gMR2OoktEXYOYPAB2b7VKeHG9paAOrACPyBHAgoJYRSEYG+mIl3wTKHjfr2ljlKwGkEXn4KaE0Y833GSE3lUllAGVMCAeMAJHTURdSnRuDl9wCtqb4JqRLgJGAE+mJarq8r4uv7iZqOL78JjYBF+iIqth/SsCvT33XDABQWc4WARkbgU3Q+/hY4xAEIAls4wJ/H/BoiCPLfserpsteuGOdzGs3zRLc4oEnfKNwZLweRLJMoeBsG85V4WiWgmds53HHgdyyGurSXZuRFBDAcZVm26451yxYUCT+TDmiGh6La2Ymw47tMMBd6i9gMQKrJdAya6Rs8J6/NmBdf909LW3jfbHd0u+molJ4JQHW4HDlIOmzS6SzKLIFkcDucBh3R9y3M1fLDzfVmrStHS/sjeM7o/gb/cqIqZuay7t5AQ9+PuV71ZAxLbwUAS19ZO1dluOyDJNrLxcbvWnEaqWLre/CUYTmoIj3hjr/TlsCoc1dcHLJGIF+nAL09hxYzI+BJgQmBFol73W2fZ8AGJhctkEF3Pf4o0CvpsIyVwJnme7mg4DR+JBDvA2gxWMO1gif0qhkE3koJTMTHG0P6k8C1ADhPVXbt2WkTyfBu4JHA/NyDFoTD2JvDYwb+gfMvnbsA9NcAPwms1wu+9lQS7k4b3ct7KBC5cfuIv5/59OsFHjMpdyRbTxoB2GzSzQ8CwTshpDjJVdAscm2VfOHskUBStdNjeiRkV5QreEASl0O5D+G8EYAidGdtgV1XndGzygHonNRgi6NeZ977kIQzX3enKUDidZ7/k9pOzqrMCrldZmM3daCDo7L37RipmeRJpJsUSKUMsiOn8bwolIDtgX5Vbbb19RDFOdkLxWup2rfl8oHANNPRzneJ6Ghi51RL3ahWcrtAE4+UO7Dqa72rVxUeGYJkftCnNKNmR7xir15bTHUmkEcncUgTUMgyjUGzjFSRqqMWp6CIY7ljCUBkKmbTxdX0GOuyNzQHIJ8uLDUGdcw8MSAIgiAIgiAIgiAIgiDIP+cbwYZo6BY4nAcAAAAASUVORK5CYII="

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAArlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8tivQqAAAAOXRSTlMAmd1md7yqRCERGbDMwVUJhw0HMgOmdMaBKGvvtlpPy52SLyWhYTk9FR3pjHxv0kk2+NZMQQHi3M5/EC1fAAAEX0lEQVR42uzQsWrDMBSF4XMlWVHBFCcu7aCSUgqd0iHjff8Xq65irCSQQVmS4XwYbGwwvw6IiIiIiIiIiIiIiIiIiJ7Cdv/+t9/iUXbTUYt8eEOjWG0cgJRnGOcB+HH9MkYYTZAABBmn/uN/6OJzdzsAIbeAGFDNrjwLgEGNlGtCt6ir78uAjRbeAkSrIPWNGrFZFEBbwEr7/Wpz/IFZTjTYDwfvasWJBOfVO3sSW0VFZLQYLe4MED1zwCJp8ksA7OZmIMaLAFsuR5HQFtCiO+JLz8RbATEA+fV6gfr6xSWsC0hAr3/262xHbRgKA/DvLCbOvpBJCCEECPuwzAzTGb//i7VeoHBDJaSqqsR3AcG24j/nWCC++ZX6dwBcAtAhJxZFxpkOcDkDsCjgx5cK+I8E8PgVAi0cXgIYvgFkQ1j+7RnQhfLtSwtM+kiAil8JocUUJr1qAeMOtWQAPgx1AMHmNhBSgwt+/EiAZMMvvlJohgmLXAWAHw4zPdFTAfQJNmUjwji04YePBEDDz96O0CxDbKG/B+QTy1cdQHeLEW47PU5hW5nhwCJD9lAANEMubU7QmB/GnGeqAjYnDteuK2ANiQMg87nB7ExEJHgsAFbl99ub/8rw9PS/6a3wT41+zPAvrYsR/q5o5kQ463+eL/pQ2ABa6jJc9HGxmq3xmztzcaGu79tR28530NaTRBd+BK0xISWtV3tTKNsjtAHJba89j2edZ9f5QCcjxfg1wl1JPW4Ya/yaQfrgPUivFrT6rQ/BHTdLarhqV36ePm22g8gpNyMVe1M6bBobjSwS7djRPji4I+sCSEGlCksCAunlBcoiGDcqQDAF9mpdHOQRhOlmDiEsXLH2x1I9xkZUJPE/gf4qwR3t3oXC1G62W2S3ASZlz9MBBkBwUMVwaAiha6EkKQBvC2UihtPCwp/YBDdIjO32JsA6WPXFzsAqqBrPk+2ocphUjtnHm78eDpRjLdYtfHrCfUEsO0cJmTBxv2KKRZBeB9hRYCIzsfF73boq9wfcYgbAkdmisiP5CJgFfSgz1aEkNvLo826AHAB6sVV+ifvNedflvLkOYG9aMv4RyRYcEkgZ9zrCSxHKFk1PzbIaU1HzDMqp0Nu6dWvhjsn7ALr5CRDVxKzM3LsKsCx2VWXu5/oQKi39tawMmLhBDqUT69sJFC+G5hY17nBLlWDwVQH4KCD4CwDWHEJeyjNef4oAut/OtytrI1awd7XV656JmXdTfRqvAFRialR0uGuyfz0c4nfR5dQu1ZCXAqVthimO6ncg2n8A668lJOJBmI8jANO9NzqNvLGaW357o+Xc8weyqsaktzPCKe475XneLuQ2JoOwnkdAtiVlhOkc0mEJJHMX0mgKtTyBiP3iddTqQ0lKSryXCNKspV4Pf5KGVfXRl1cOpM91H0gWh2UKtobEXKC/jiA56c37wNyZA5xlpvn7U7ObR3h6evrZHhwSAAAAAAj6/9obBgAAAACYCK6Kd1XA/S7rAAAAAElFTkSuQmCC"

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAY1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+aRQ2gAAAAIHRSTlMApzjdbyIPd96ZZlQqRNHDu4t9tRzuVTPMhmLvpWhMAdMfP38AAALbSURBVHja7dWLjtsgEAXQAewhGIzfdpK++P+v7CwhxHa3XlVJq5U6R1lnFBO4wrMEGGOMMcYYY4wxxhhjjDHGGGPsc0ApEbZK+kP4N743gbT1Zv1QAqoFIvV2S5tYVwLIeQYSP3zajy4kehdgngzBbQBUNOyiSirrkJTwjD5kV7ibddBLSwHaaROgrKpLW+nJVNVCAUBrivRcgDI8fEFIWhVUO51nVBdo6Y6iC9GzyjQFQEqI9AZPuISVb3A3B631MrWC6iU+HKVgpw50mUIw8IwmrHxd5VIaqymYBUCHsEAVQv1rgBfwYaWFBFWoxXnSdRsMnCejUBllAGCpkiU3IVlevgO6DaU+a1rIVPVZ1Zfpoo0q6cajBd6EMl1f3QPtHMoyKBLKtlK1VqiNFrA/Kuilarq+/L+gptnpFVcRqObzAtqg0u99MwZ49TkAqwCPc6Bq5yqb4W6e/spJmB/B+iBqVdZCdM5ffPlvQRmoCfUT2/v0r2F5e2eM/a9kJ4SREFnR2zFW4o3NlQPSw42LhbNw10FiNyMsTVyM8IGusYi2uc1RXKUxsTpJMuYKY1WkyCJeC0jGU52qk12PKDope1/Aod4gEBxi5kIC+tuyEG2rwb4bgLYwVUNj1wGKOLOFA84jRDimANAVvw2QJtsFQI/NCJFw3u4CgPRwoOhzmQLIk3ts/K6COP8+gO3yNIJG1LsAMMijAPHmeF+jGJr0zE6CuF0FMcE+AC0w+nsAcI3bBegPA9jUrsLLuCHDbuP3lfNuF8B5Sj/YFCAm2AYwRwGsgMTfNsT0hwHi/NsA3UDxB5EDgPVuHQA9woGmhugqbgGwkccBoPbXHOAxfzPmAJTgugrQdXDENde4vnf3JmzwOADY0zqA7VbdLO4jcgDsBoRDTjTGeDPmnuy73Hp214Sb5yab+PEQb6U2FJsRRSMG3yF8ZJQS4Y84+IgExhhjjDHGGGOMMcY+n5/DzjUoMfyHpwAAAABJRU5ErkJggg=="

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAaVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8G612AAAAInRSTlMAId3AQJmAZncQ8eDQoGBwu7HuzJBEUFWrMDT5iAjphE1BxTj6ZQAAAtFJREFUeNrt1GmPmzAQgOGxscE2901Itof//4/swJijTb8UVqqqzqMo641X+LVhA4wxxhhjjDHGGGOMMcYYY4wxxpD9mj2frbHwlwzOr758h0PlyQvHYxKMYPzOADQzzhoN93x7+uA5v01WBt8kahqJAAmPLwEoqeATAuwXv5MfsJsMINkvbwmA1rjgKYAmdbWdxnWlPxlh167jdSVZad22WlcSRGNDgBRGC4nbx5e+E1D7Ew0b6y3t9ucAaEYKmL1tvO9p9VsBrT+pYDP7TQLSCKG1EAYDXhMFvCbMW7cvp08MmH4zjwE+wIC+mdeA9bmwMOm+keZWgPYnMbzBlUxPJ9Av6zRmCUgaC8lyZJU0o2/vBMz+8BRAjk33chQJqqoE4fy0Brw0jioDxuNASwM3TH7XwTvfj8f3wHj6N0SJlBqQvhVgWx/UH/Cm9zMstAZyBPRtO5t7AeTj9fTIvV/F4Mfayu0EkD/IKqGvQdxAD/fYsSyHsP13yQkwxv4jHaxECUGptpkoHiyNgIhtUDx+HeQWrrFe0AVyCNJtFJVDFtMISOz2wSMM1HaZEq5RrgNkXQZEZc6GAAXC2XOAi4qwbkYFe0CZpXBN3DlARe6A5EVe7gGQqVNAUauQGcdFZs8B6QP/+pJa5QUsC9V0AeusSPeAwYtTQDTgQiEAqCAEqAy3AJekVuHlHxnEtO8yp62jKHOugCNApDRNAdBldg9YNuEEXGBTbBDLBVRNQYVSHQ2jiH5uAV2t1ODsFgB5ZkOA9YNSdQwXqBx31dnULilIpRGizUQqK88BLkJpsQdgQQgo03UKLlgO3rr1/mEEQF0A6mIKEKk4Aoqa7vYRAHlOAakIj8gfo9ud+8eyNg6FC3c7zJVRCKBf6XmnAJpwy4dDBKHwz7mfdxV3+/NOK0Z0FhQVntJTgM3Ufmz0GF6j4CorgDHGGGOMMcYYY4yxf8UPl+A21xu6V/cAAAAASUVORK5CYII="

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAnFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+TINBkAAAAM3RSTlMAIneZvN1mBUMXpJ4L7jPMyKqXdRKzh109N4tVG5OOMSvSxK4muID5px5Hb2liV0zi1/A1/F3YAAADJklEQVR42u3V6ZaaMBgG4JeQsAqIBVzAddyd0ba5/3vrRxBkzumvMj3tj+85CiEgeSGLYIwxxhhjjDHGGGOMMcYYY4wxVvNWeb6Y4V/Zj7VxqPASxbQRNoyuZGkQbZkq3REYwor003cfLUe+mk0dU6JvL0Cbx6KDgba6c0BLebZsn85Som7cUdZfCVDqnln3xqlVG/SxBSiBJexMWf0ukMKKsmcANShDoHtWaFCveKZ1+nweA0RoK0skXVQ2AWKdYYCx7snxZJnHVykFULqjnm+gVHWeIm0CFCm+PoCdIbW9iPpBNP0Uid4siBwQL4pNAOVgiPPvusChspRKlDqpG45VYSdefxoakagDOFGGIe6/G4SpFBDaBmwlKE4U06iMvH6Akk6mJkBhf900lOg4Spkb2yJLVVwPiFildQBPOnUAIb9sHdi8FqIKT16SxOIZQMqsmQWZlJZOEgEdU33RBfiypVhe0JLPxS/R2utPQ88MuFSTWL8oDOQtzZ8RY4z1jEZtoUKj8tHwM7Nzm+PM7HzPs9AdG9UIQ3yEMxj3wIWR39EoiyZHaJkLVyCrQ/69qb4t0ZBXDFFuT2tTmOZNgLj7q75pH8T76YE4k/o1LWfwTlMQEcC46iOGeJf5j70J8NYEWAZvGxgrbVoKT7dXgHodt3OQbyGMIEgzDPBtt//Y+q8A1tidNI80Co9pXXFehJ8DyKIXYD12g9ugAOM5jtuqCyBCrKUpxfkluAOL4/owagO4y4lQ0aUXoFjhmg8NgPM2awNIx612ZdMneD/D3c2QrnsBbsH2/Argjh/Yj69DAyDYojQBHqedlCdz7+MCl131ONDZ6acuqL6/dwHudP3hVAwOgOA8Pbv1fmnNN9eE6txJCSwXNjW2KLoAK4+2k7AL8HbczzeP8WZwAIS6vuE62YPY1KJ/oLvG0Y+6MwK3DVDMaZNM2wCznQ+SfsMfE0kTwE2kmYOozbcXzCWItGmz2VUmAAl2q4Namh56qw8XqF2TGf7UZT2C4T+osPZhxCP4G6Ct2NCpam9KH+8fnmt+SMdud70PxhhjjDHGGGOMMcb+f78A50RZHXPVua0AAAAASUVORK5CYII="

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00000.6eb12f7.jpg";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00001.7ddb6a7.jpg";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00002.0fd9613.jpg";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00003.fa866db.jpg";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00004.87be649.jpg";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00005.6f47587.jpg";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00006.b86ce20.jpg";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00007.739e988.jpg";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00008.41d7c9f.jpg";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00009.b80af52.jpg";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00010.4d60e20.jpg";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00011.88cedc8.jpg";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kf_cloud_00012.25e4d52.jpg";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wx_share_img.699cfd4.png";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(202),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(200),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(205),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(196),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(201),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(208),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(203),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(199),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(206),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(204),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-audioSprite",
    staticStyle: {
      "display": "none"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-page"
  }, [_c('div', {
    ref: "wrapper",
    staticClass: "c-page__wrapper"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('div', {
    staticClass: "c-loading"
  }, [_c('div', {
    staticClass: "c-loading__text"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-loading__orbits"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-loading__progress"
  }, [_vm._v(_vm._s(_vm.progress) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "c-loading__tips"
  }, [_vm._v("打开声音体验更佳")])])])
},staticRenderFns: []}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-endCover"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-endCover__slogan"
  }), _vm._v(" "), _c('div', {
    ref: "actions",
    staticClass: "c-endCover__actions"
  }, [_c('span', {
    staticClass: "c-endCover__backBtn",
    on: {
      "click": _vm.handleBack
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "c-endCover__registerBtn",
    on: {
      "click": _vm.handleRegister
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-endCover__texts"
  }, [_c('div', {
    staticClass: "c-endCover__text line1"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-endCover__text line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-endCover__text line3"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-endCover__text line4"
  })])
}]}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-meteor"
  })
},staticRenderFns: []}

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-clouds"
  }, [_c('div', {
    ref: "container",
    staticClass: "c-clouds__spriteContainer"
  })])
},staticRenderFns: []}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audio', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.audioSrc,
      "autoplay": "",
      "loop": ""
    }
  })
},staticRenderFns: []}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-earth"
  }, [_c('div', {
    ref: "mountNode"
  })])
},staticRenderFns: []}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('div', {
    class: {
      'c-show': true, 'low-position': _vm.isEnd
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('show-cover', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEnd),
      expression: "!isEnd"
    }],
    attrs: {
      "show-tips": _vm.showTips,
      "show-coord": _vm.showCoord,
      "coord-index": _vm.coordIndex
    }
  })], 1), _vm._v(" "), (_vm.isEnd) ? _c('show-end-cover', {
    on: {
      "back": _vm.handleBack
    }
  }) : _vm._e(), _vm._v(" "), _c('show-earth', {
    ref: "earth"
  }), _vm._v(" "), _c('show-clouds', {
    ref: "cloudSprite"
  }), _vm._v(" "), _c('show-video-sprite', {
    ref: "videoSprite"
  }), _vm._v(" "), _c('show-audio-sprite', {
    ref: "audioSprite",
    on: {
      "spriteend": _vm.handleAudioSpriteEnd
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('show-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEnd),
      expression: "!isEnd"
    }],
    attrs: {
      "show-press-button": !_vm.showTips,
      "show-xplan-button": _vm.showXplanButton && _vm.revealed
    },
    on: {
      "hold": _vm.handleHold,
      "release": _vm.handleRelease,
      "knowmore": _vm.handleKnowMore
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-actions"
  }, [_c('span', {
    class: {
      'c-actions__longPressText': true, 'is-active': _vm.showPressButton
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'c-actions__longPress': true, 'is-active': _vm.showPressButton
    },
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.handleStart($event)
      },
      "touchend": _vm.handleEnd,
      "touchcancel": _vm.handleEnd
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'c-actions__xplan': true, 'is-active': _vm.showXplanButton
    },
    on: {
      "click": _vm.handleClickXPlan
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-videoSprite"
  }, [_c('video', {
    ref: "video",
    staticClass: "c-videoSprite__video",
    attrs: {
      "src": _vm.videoSrc,
      "webkit-playsinline": "",
      "playsinline": ""
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "progress": _vm.progress
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('show') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('meteor') : _vm._e(), _vm._v(" "), _c('background-audio'), _vm._v(" "), _c('footer', {
    staticStyle: {
      "position": "fixed",
      "z-index": "100",
      "bottom": "0",
      "width": "100%",
      "padding": "4px",
      "color": "rgba(255,255,255,.7)",
      "text-align": "center"
    }
  }, [_vm._v("ygjack414@hotmail.com")])], 1)
},staticRenderFns: []}

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-earthCover"
  }, [_c('div', {
    staticClass: "c-earthCover__cover"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCoord),
      expression: "showCoord"
    }],
    staticClass: "c-earthCover__coord",
    style: ({
      backgroundPosition: _vm.backgroundPosition
    })
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTips),
      expression: "showTips"
    }],
    staticClass: "c-earthCover__tips"
  }, [_c('div', {
    staticClass: "c-earthCover__hand"
  })])])], 1)
},staticRenderFns: []}

/***/ })
],[74]);


// WEBPACK FOOTER //
// static/js/app.18694df1ec6b9ff42309.js